import HrDashboard from "./Hr_dashboard";
import HrDashboardAside from "./HrDashboardAside";
import './layouts.css'

function HrDashboardLayout(){

    return(
        <div className="layout">
        <HrDashboardAside className="asideBar"/>
        <HrDashboard className="mainBlock"/>
        </div >
    )
}
export default HrDashboardLayout;